import React from 'react'

function MobileIcon() {
  return (
    <div>
     <svg width="22px" height="22px" viewBox="0 0 1024 1024" data-aut-id="icon" class="_2oC8g" fill-rule="evenodd"><path class="rui-4K4Y7 _3Z_D3" d="M743.68 85.333l66.987 67.84v701.227l-63.573 84.267h-471.253l-62.507-85.333v-700.373l67.627-67.627h462.72zM708.053 170.667h-391.893l-17.493 17.707v637.653l20.053 27.307h385.92l21.333-27.52v-637.653l-17.92-17.493zM512 682.667c23.564 0 42.667 19.103 42.667 42.667s-19.103 42.667-42.667 42.667c-23.564 0-42.667-19.103-42.667-42.667s19.103-42.667 42.667-42.667z"></path></svg>
    </div>
  )
}

export default MobileIcon
